// modules
import { parse } from 'bowser';
// constants
import { MOBILE_BREAKPOINT } from './consts';

class PlatformService {
  deviceInfo = parse(window.navigator.userAgent);
  isMobile = window.screen.width <= MOBILE_BREAKPOINT;
  private browser = this.deviceInfo.browser;
  private os = this.deviceInfo.os;
  private platform = this.deviceInfo.platform;

  public isIpad = window?.screen?.width < MOBILE_BREAKPOINT;

  get isIOS() {
    return this.deviceInfo.os.name === 'iOS';
  }

  getDeviceDetails = (fetchPlatformDetail = false): DeviceInfo => ({
    manufacturer: this.deviceInfo.engine.name ?? 'unknown',
    os: `${this.os.name}/${this.os.version}`,
    osVersion: `${this.browser.name}/${this.browser.version}`,
    browserName: this.browser.name ?? 'unknown',
    ...(fetchPlatformDetail && { device: `${this.platform.type}` }),
  })

  isValidBrowser = () => {
    const validBrowsers = ['Chrome', 'Safari', 'Opera', 'Firefox', 'Microsoft Edge'];
    return validBrowsers.includes(this.browser.name as string);
  }

  get isSafari() {
    return this.browser.name === 'Safari';
  }
}

export default new PlatformService();
